import config from "@/config"
import http from "@/utils/request"

export default {
	upload: {
		url: `${config.API_URL}/manage/publicCommon/upload`,
		name: "文件上传",
		post: async function(data, config={}){
			return await http.post(this.url, data, config);
		}
	},
	uploadFile: {
		url: `${config.API_URL}/manage/publicCommon/upload`,
		name: "附件上传",
		post: async function(data, config={}){
			return await http.post(this.url, data, config);
		}
	},
	// 支付证书上传（pem/crt；成功返回 path=服务器绝对路径，回填支付配置表单）
	uploadCert: {
		url: `${config.API_URL}/manage/member.publicCommon/uploadCert`,
		name: "支付证书上传",
		post: async function(data, config={}){
			return await http.post(this.url, data, config);
		}
	},
	exportFile: {
		url: `${config.API_URL}/fileExport`,
		name: "导出附件",
		get: async function(data, config={}){
			return await http.get(this.url, data, config);
		}
	},
	importFile: {
		url: `${config.API_URL}/fileImport`,
		name: "导入附件",
		post: async function(data, config={}){
			return await http.post(this.url, data, config);
		}
	},
	delFile: {
		url: `${config.API_URL}/manage/publicCommon/delFile`,
		name: "删除文件",
		post: async function(data, config={}){
			return await http.post(this.url, data, config);
		}
	},
	file: {
		menu: {
			url: `${config.API_URL}/manage/member.publicCommon/getUploadFileGroup`,
			name: "获取文件分类",
			get: async function(){
				return await http.get(this.url);
			}
		},
		del: {
			url: `${config.API_URL}/manage/member.publicCommon/delUploadFileGroup`,
			name: "删除文件分类",
			post: async function(data){
				return await http.post(this.url,data);
			}
		},
		add: {
			url: `${config.API_URL}/manage/member.publicCommon/addUploadFileGroup`,
			name: "添加文件分类",
			post: async function(data){
				return await http.post(this.url,data);
			}
		},
		edit: {
			url: `${config.API_URL}/manage/member.publicCommon/editUploadFileGroup`,
			name: "编辑文件分类",
			post: async function(data){
				return await http.post(this.url,data);
			}
		},
		list: {
			url: `${config.API_URL}/manage/member.publicCommon/getUploadFiles`,
			name: "获取文件列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		}
	}
}
